import Vue from "vue";
import {
    Button,
    Message,
    MessageBox,
    Form,
    FormItem,
    Input,
    Checkbox,
    Loading,
    Select,
    Option,
    dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Carousel,
    CarouselItem,
    Tabs,
    TabPane,
    Pagination
} from 'element-ui';

Vue
    .use(Button)
    .use(Form)
    .use(FormItem)
    .use(Input)
    .use(Checkbox)
    .use(Select)
    .use(Option)
    .use(Dropdown)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(dialog)
    .use(Loading.directive)
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Menu);
    Vue.use(Submenu);
    Vue.use(MenuItem);
    Vue.use(MenuItemGroup);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Pagination);
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$loading = Loading.service;